/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_PartnershipsInputs */

const en_directory_footer_link_partnerships = /** @type {(inputs: Directory_Footer_Link_PartnershipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnerships`)
};

const zh_directory_footer_link_partnerships = /** @type {(inputs: Directory_Footer_Link_PartnershipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合作伙伴`)
};

/**
* | output |
* | --- |
* | "Partnerships" |
*
* @param {Directory_Footer_Link_PartnershipsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_partnerships = /** @type {((inputs?: Directory_Footer_Link_PartnershipsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_PartnershipsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_partnerships(inputs)
	return zh_directory_footer_link_partnerships(inputs)
});
export { directory_footer_link_partnerships as "directory.footer.link_partnerships" }